import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import { useDeliveryPickup } from '~/context/vdp/DeliveryPickupContext';
import useIsNotAvailableForImmediatePurchase from '~/hooks/vdp/selectors/useIsNotAvailableForImmediatePurchase';

export default function useDeliveryPickupLoadedOrWillNotLoad(): boolean {
  const { isLoaded } = useDeliveryPickup();
  const isDealership = useIsDealershipPage();
  const isNotPurchasable = useIsNotAvailableForImmediatePurchase();

  return isDealership || isLoaded || isNotPurchasable;
}
